import "./dropdownMenuMobile.scss";

import React, { useState } from "react";

import classNames from "classnames";
import { Link, withPrefix } from "gatsby";

interface dropdownInterface {
  items?: any[];
  dropdownTitle: string;
}

function Button({ className, onClick, isOpen, items }: any) {
  return (
    <button className={className} onClick={onClick}>
      {!!items &&
        (isOpen ? (
          <svg
            height="24"
            fill="rgb(70,70,70)"
            viewBox="0 0 24 24"
            width="24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="m0 0h24v24h-24z" fill="none" />
            <path d="m7.41 15.41 4.59-4.58 4.59 4.58 1.41-1.41-6-6-6 6z" />
          </svg>
        ) : (
          <svg
            height="24"
            fill="rgb(70,70,70)"
            viewBox="0 0 24 24"
            width="24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="m0 0h24v24h-24z" fill="none" />
            <path d="m7.41 8.59 4.59 4.58 4.59-4.58 1.41 1.41-6 6-6-6z" />
          </svg>
        ))}
    </button>
  );
}

function DropdownMenuMobile({ items, dropdownTitle }: dropdownInterface) {
  const [isOpen, setIsOpen] = useState(false);
  const [isOpenSubmenu, setIsOpenSubmenu] = useState(false);
  const [currentSubmenu, setCurrentSubmenu] = useState(null);

  const keyHandler = (event) => {
    if (event.key === "Escape" && isOpen) {
      setIsOpen(false);
    }
  };

  const openSubMenu = (submenu) => {
    setCurrentSubmenu(submenu);
  };

  const closeSubMenu = () => {
    setCurrentSubmenu(null);
  };

  const handleClickSubmenu = (item: any, currentItem: any) => {
    setIsOpenSubmenu(!isOpenSubmenu);
    return isOpenSubmenu && currentItem
      ? closeSubMenu()
      : openSubMenu(item.submenu);
  };

  const pathMap = {
    "Agendar cita": withPrefix(
      "/servicios/nutricionistas/cita-individual-de-nutrición/"
    ), //TODO: path must be changed
    Biblioteca: withPrefix("/biblioteca"), //TODO: path must be changed
    "Planes nutricionales": withPrefix("servicios/planes-nutricionales"), //TODO: path must be changed
    Nutricionistas: withPrefix("servicios/nutricionistas"), //TODO: path must be changed
  };

  const redirectClick = (clickedItem) => {
    const path = pathMap[clickedItem];
    // TODO: lógica temporal ya que el negocio NO quiere que se redireccione a nutricionistas por el momento
    if (path && path !== "/servicios/nutricionistas") {
      window.location.href = path;
    }
  };

  return (
    <div className={"dropdown_wrapper_mobile"}>
      <div className="dropdown_activator_container_mobile">
        <span onClick={() => redirectClick(dropdownTitle)}>
          {dropdownTitle}
        </span>
        <Button
          className={"dropdown_activator_mobile"}
          onClick={() => setIsOpen(!isOpen)}
          isOpen={isOpen}
          items={items}
        />
      </div>
      {!!items && (
        <ul
          className={classNames("dropdown_item_list_mobile", {
            active: isOpen,
          })}
        >
          {items?.map((item, index) => {
            const hasSubMenu = item?.submenu?.length > 0;
            return (
              <li
                className={"item_list_mobile"}
                key={`${index}_${item.anchor}`}
                // onMouseEnter={() => openSubMenu(item.submenu)} // Abre el submenú al pasar el mouse
                // onMouseLeave={closeSubMenu}
              >
                {!hasSubMenu && <Link to={item.slug}>{item.anchor}</Link>}
                {hasSubMenu && (
                  <div className="dropdown_activator_submenu_mobile">
                    <Link to={item.slug}>{item.anchor}</Link>
                    <Button
                      isOpen={
                        isOpenSubmenu &&
                        item.submenu &&
                        currentSubmenu === item.submenu
                      }
                      // className={"dropdown_activator_submenu_mobile"}
                      onClick={() => {
                        const currentItem =
                          item.submenu && currentSubmenu === item.submenu;
                        handleClickSubmenu(item, currentItem);
                      }}
                    />
                  </div>
                )}

                {item.submenu && currentSubmenu === item.submenu && (
                  <div className={"submenu_wrapper_mobile"}>
                    <ul>
                      {item.submenu.map((subitem, subindex) => (
                        <li key={subindex}>
                          <Link to={subitem.slug}>{subitem.title}</Link>
                        </li>
                      ))}
                    </ul>
                  </div>
                )}
              </li>
            );
          })}
        </ul>
      )}
    </div>
  );
}

export default DropdownMenuMobile;
